import { log } from '../app/logger.js';

// depends on window.Marker

/**
 * A temporary marker that substitutes the original location marker.
 */
class SwapMarker {
  constructor(map, { name, onmove, onaccept }) {
    this.map = map;

    this.origMarker = null;
    this.tmpMarker = window.Marker.Standard({
      map,
      name,
      visible: false,
      clickable: true,
    });

    if (onmove) {
      this.tmpMarker.on('drag', onmove);
      this.tmpMarker.on('dragend', onmove);
    }
    this.tmpMarker.on('click', () => {
      // do nothing: if leaflet marker has no click event registered, then
      // click event is propagated to the map.
    });
    if (onaccept) {
      this.tmpMarker.on('dblclick', onaccept);
    }
  }

  swapFor(origMarker, position) {
    let marker_name = (origMarker && position.name) || 'no';
    let pos_str = `(${position.lat}, ${position.lng})`;
    log(
      `[map:marker] swap ${marker_name} marker for a temporary one placed at ${pos_str}`
    );

    // If we had a previous marker, then show it: we don't longer manage it.
    if (this.origMarker) {
      this.origMarker.attachTo(this.map);
    }

    // Replace the original marker on a temporary one.
    if (origMarker) {
      origMarker.deattach();
    }

    this.tmpMarker.position = position;
    this.tmpMarker.attachTo(this.map);
    this.tmpMarker.visible = true;
    this.origMarker = origMarker;
  }

  isSwapped() {
    return this.origMarker;
  }
  isSwappedFor(marker) {
    return marker && marker == this.origMarker;
  }

  release(doNotShowOrigMarker) {
    let marker_str =
      (this.origMarker &&
        !doNotShowOrigMarker &&
        `(${this.origMarker.position.lat}, ${this.origMarker.position.lng})`) ||
      'none';
    log(`[map:marker] hide temporary marker in favor to ${marker_str} marker`);

    this.tmpMarker.deattach();
    if (this.origMarker && !doNotShowOrigMarker) {
      this.origMarker.attachTo(this.map);
    }
    this.origMarker = null;
  }

  get position() {
    return this.tmpMarker.position;
  }
  set position(v) {
    this.tmpMarker.position = v;
  }
  get draggable() {
    return this.tmpMarker.draggable;
  }
  set draggable(v) {
    this.tmpMarker.draggable = v;
  }
}

export { SwapMarker };
